import { indexedDB, resetStorage, sessionStorage } from "./storageDrivers";
export const storageDrivers = {
  indexedDB,
  resetStorage,
  sessionStorage
}; // This object is once mutated when the 'configure' ('../configure') method is called.
// On this call custom configuration is merged with default configuration.
// The final configuration is validated and then freezed.

export const config = {
  initialized: false
};
export let PetrusErrorType;

(function (PetrusErrorType) {
  PetrusErrorType[PetrusErrorType["CONFIGURE_METHOD_CAN_BE_CALLED_ONLY_ONCE"] = 0] = "CONFIGURE_METHOD_CAN_BE_CALLED_ONLY_ONCE";
  PetrusErrorType[PetrusErrorType["INVALID_AUTHENTICATE_HANDLER"] = 1] = "INVALID_AUTHENTICATE_HANDLER";
  PetrusErrorType[PetrusErrorType["INVALID_GET_AUTH_USER_HANDLER"] = 2] = "INVALID_GET_AUTH_USER_HANDLER";
  PetrusErrorType[PetrusErrorType["INVALID_REFRESH_TOKENS_HANDLER"] = 3] = "INVALID_REFRESH_TOKENS_HANDLER";
  PetrusErrorType[PetrusErrorType["INVALID_OAUTH_CONFIG"] = 4] = "INVALID_OAUTH_CONFIG";
  PetrusErrorType[PetrusErrorType["INVALID_TIMEOUT"] = 5] = "INVALID_TIMEOUT";
  PetrusErrorType[PetrusErrorType["INVALID_TOKENS"] = 6] = "INVALID_TOKENS";
  PetrusErrorType[PetrusErrorType["UNAVAILABLE_TOKENS"] = 7] = "UNAVAILABLE_TOKENS";
  PetrusErrorType[PetrusErrorType["UNAVAILABLE_AUTH_USER"] = 8] = "UNAVAILABLE_AUTH_USER";
  PetrusErrorType[PetrusErrorType["GET_AUTH_USER_FAILURE"] = 9] = "GET_AUTH_USER_FAILURE";
  PetrusErrorType[PetrusErrorType["LOGIN_FAILURE"] = 10] = "LOGIN_FAILURE";
  PetrusErrorType[PetrusErrorType["LOGOUT_FAILURE"] = 11] = "LOGOUT_FAILURE";
  PetrusErrorType[PetrusErrorType["REFRESH_TOKENS_FAILURE"] = 12] = "REFRESH_TOKENS_FAILURE";
  PetrusErrorType[PetrusErrorType["DIRECT_LOGIN_FAILURE"] = 13] = "DIRECT_LOGIN_FAILURE";
  PetrusErrorType[PetrusErrorType["GET_OAUTH_TOKENS_FAILURE"] = 14] = "GET_OAUTH_TOKENS_FAILURE";
  PetrusErrorType[PetrusErrorType["SET_ACCESS_TOKEN_REFRESHMENT_TIMER_FAILURE"] = 15] = "SET_ACCESS_TOKEN_REFRESHMENT_TIMER_FAILURE";
  PetrusErrorType[PetrusErrorType["CLEAR_TOKENS_FAILURE"] = 16] = "CLEAR_TOKENS_FAILURE";
  PetrusErrorType[PetrusErrorType["SET_TOKENS_FAILURE"] = 17] = "SET_TOKENS_FAILURE";
  PetrusErrorType[PetrusErrorType["SET_TOKENS_PERSISTENCE_FAILURE"] = 18] = "SET_TOKENS_PERSISTENCE_FAILURE";
})(PetrusErrorType || (PetrusErrorType = {}));

export class PetrusError extends Error {
  originalError;
  type;

  constructor(type, message, originalError) {
    super(message);
    this.name = 'PetrusError';
    this.type = type;
    this.originalError = originalError;
  }

}
/**
 * TS type guard function for PetrusError.
 * @category Utilities
 */

export const isPetrusError = error => error instanceof PetrusError;